import {SDrawerOrModal, SGeneralForms} from "shj-components";
import {Form, message} from "antd";
import {importExportTaskDownloadExcel} from "@/services/saleOpServices.ts";
import {fileConfirm} from "@/utils/file.ts";
import {useEffect, useState} from "react";
import dayjs from "dayjs";
const TaskObj = {
  'ClueInfoDyhExcelImpl': {
    taskName: '线索导出',
    modalTitle: '导出 (Zip)',
    label: '选择开始结束时间， 最多100天'
  },
  'ClueFollowLogExcelImpl': {
    taskName: '跟进记录导出',
    modalTitle: '导出明细',
    label: '选择开始结束时间， 最多7天'
  },
}

const ExportModal = (props) => {
  const {open, onClose, taskCode} = props;
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if(open) {
      form.setFieldValue('time', [dayjs().subtract(6, 'days'), dayjs()])
    }
  }, [open]);

  const onExportFn = () => {
    form.validateFields().then(values => {
      const {time} = values
      const startTime = time?.[0]?.format('YYYY-MM-DD');
      const endTime = time?.[1]?.format('YYYY-MM-DD');
      const searchObj = {
        taskName: TaskObj[taskCode].taskName + ' ' + startTime + '至' + endTime,
        taskCode,
        taskSource: "CRM",
        taskRemark: TaskObj[taskCode].modalTitle,
        reqParam: {},
      }
      searchObj.reqParam = {startTime: startTime + ' 00:00:00', endTime: endTime + ' 23:59:59'}
      searchObj.reqParam = JSON.stringify(searchObj.reqParam)
      console.log(searchObj)
      setLoading(true)
      importExportTaskDownloadExcel(searchObj)
          .then(() => {
            onClose()
            fileConfirm()
          })
          .finally(() => {
            setLoading(false)
          })
    })

  }

  const disabledDate = (current, { from }) => {
    if (from) {
      const diff = Math.abs(current.diff(from, 'days'));
      const day = taskCode === 'ClueInfoDyhExcelImpl' ? 99 : 6
      return diff > day;
    }
    return false;
  };

  return <SDrawerOrModal
      title={TaskObj[taskCode]?.modalTitle}
      onCancel={onClose}
      okText={'确定'}
      open={open}
      onOk={onExportFn}
      mode={'modal'}
      width={500}
      loading={loading}
    >
      <SGeneralForms
          layout={'vertical'}
          formConfig={{form}}
          configs={[{
            formItem: [
              {
                spanCol: 24,
                name: 'time',
                required: true,
                rules: [{required: true, message: '时间不能为空'}],
                label: TaskObj[taskCode].label,
                type: 'range',
                comConfig: {
                  style: {width: '100%'},
                  disabledDate,
                },
              }
            ]
      }]}/>
    </SDrawerOrModal>
}

export default ExportModal